import '@babel/polyfill';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue';
import router from './router';
import store from './store';
import api from './api';
import env from './.env';
import packageJSON from '../package.json';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import ToggleButton from 'vue-js-toggle-button';
import vClickOutside from 'v-click-outside';
import VueAutosize from 'vue-autosize';
import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';
import VTooltip from 'v-tooltip';
import VueNumeric from 'vue-numeric';
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import VueAnalytics from 'vue-analytics';
import VueInputAutowidth from 'vue-input-autowidth';
import smoothscroll from 'smoothscroll-polyfill';
import VueCompositionAPI from '@vue/composition-api'

console.log('Acada: v' + packageJSON.version);

smoothscroll.polyfill();
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(ToggleButton);
Vue.use(vClickOutside);
Vue.use(VueAutosize);
Vue.use(VTooltip);
Vue.use(VueNumeric);
Vue.use(VuejsDialog);
Vue.use(VueInputAutowidth);
Vue.use(VueAnalytics, { id: env.GA });
Vue.use(VCalendar, {
  paneWidth: 205,
  firstDayOfWeek: 1, // Sunday
  popoverVisibility: 'focus',
  formats: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['D MMM YYYY'],
    dayPopover: 'D MMM YYYY',
    data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
    color: '#5BA0EB',
  },
});
Vue.use(VueCompositionAPI)

new Vue({
  router,
  store,
  api,
  render: h => h(App),
}).$mount('#app');
